import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { toggleElement, toggleEnableElement, toggleClass, hideElement, displayElement } from '@fretadao/f-js-dom';


application.register(
  'toggle-field',
  class extends Controller {
    static targets = ['fieldToManageToggle', 'fieldToToggle'];

    AFREX_ID = '166';
    AFREX_NAME = 'AFREX';

    connect() {
      this.#toggleAfrex();
    }

    fieldToManageToggleTargetConnected(target) {
      this.#toggleAfrex();

      $(`#${target.id}`).on('change', () => this.#toggleAfrex())
    }

    fieldToManageToggleTargetDisconnected() {
      this.#toggleAfrex();
    }

    #toggleAfrex() {
      const customerField = this.fieldToToggleTarget;

      let shouldDisplayField = true;

      if (this.fieldToManageToggleTargets.length === 0) return;

      this.fieldToManageToggleTargets.forEach((field) => {
        if (this.#elementIsAfrex(field)) shouldDisplayField = false;
      });

      if (shouldDisplayField) {
        hideElement(customerField.parentElement);
      } else {
        displayElement(customerField.parentElement);
      }
    }

    #elementIsAfrex(target) {
      return target.value === this.AFREX_ID || target.title === this.AFREX_NAME;
    }
  }
)
